module.exports = __webpack_public_path__ + "static/media/linkMainImg.68be4862.png";